import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App as AntApp } from 'antd';
import ErrorBoundry from './components/Utility/ErrorBoundry';
import RequireAuth from './components/RequireAuth';
import Admin from './components/Admin/Admin';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PrivacyPolicyPage from './pages/Legal/PrivacyPolicy';
import TermsAndConditionsPage from './pages/Legal/TermsAndConditions';
import ForgotPasswordPage from './pages/ForgotPage/ForgotPasswordPage';
import PaymentSuccessPage from './pages/PaymentSuccess';
import PaymentCancelPage from './pages/PaymentCancel';
import CheckoutPage from './pages/Checkout';
import CheckoutErrorPage from './pages/CheckoutError';
import useAuth from './hooks/useAuth';

function ReturnToRedirect() {
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (loading || !isAuthenticated) return;
    const returnTo = sessionStorage.getItem('checkout_returnTo');
    if (returnTo && returnTo.startsWith('/')) {
      sessionStorage.removeItem('checkout_returnTo');
      window.location.replace(returnTo);
    }
  }, [loading, isAuthenticated]);

  return null;
}

const App = () => {
  return (
    <ErrorBoundry>
      <AntApp>
        <BrowserRouter>
          <ReturnToRedirect />
          <Routes>
            {/* Rutas públicas */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot" element={<ForgotPasswordPage />} />
            <Route path="/auth/activate" element={<ResetPasswordPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
            <Route path="/payment/success" element={<PaymentSuccessPage />} />
            <Route path="/payment/cancel" element={<PaymentCancelPage />} />
            <Route path="/checkout/error" element={<CheckoutErrorPage />} />

            {/* Rutas privadas: Requieren autenticación */}
            <Route
              path="/checkout"
              element={
                <RequireAuth>
                  <CheckoutPage />
                </RequireAuth>
              }
            />

            <Route
              path="/"
              element={
                <RequireAuth>
                  <Admin />
                </RequireAuth>
              }
            />

            <Route
              path="*"
              element={
                <RequireAuth>
                  <Admin />
                </RequireAuth>
              }
            />
          </Routes>
        </BrowserRouter>
      </AntApp>
    </ErrorBoundry>
  );
};

export default App;
